<template>
  <div v-if="!isPending">
    <div class="mb-1">
      <b>Crew Members:</b>
      <slot name="header-addon"><span class="hint-label">(Current)</span></slot>
    </div>
    <div v-if="!crewMembers.length">--</div>
    <div
      v-for="(member, i) in crewMembers"
      :key="member.id + i"
      class="truncate-row"
    >
      <truncate-text :text="member.full_name" class="mr-1"></truncate-text>
      <span class="whitespace-nowrap">{{ member.phone }}</span>
    </div>
  </div>
</template>

<script>
import TruncateText from "@/components/TruncateText.vue";

export default {
  components: {
    TruncateText,
  },
  props: {
    crewMembers: {
      type: Array,
      default: () => [],
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasCrewMembers() {
      return this.crewMembers.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.truncate-row {
  display: flex;
  width: 100%;
}
</style>
